import "../css/style.scss"
// For translation use the __(string, domain) function
//const __ = wp.i18n.__
import $ from "jquery";



//Modules 
import "./modules/Accordion.js";
import "./modules/RangeSlider.js";
import "./modules/Slider.js";
import "./modules/NumberInput.js";
import "./modules/Popup.js";
import "./modules/Switch.js";
import "./modules/FileUpload.js";
import "./modules/Form.js";
import "./modules/NotificationBanner.js";
import "./modules/Faq.js";
import "./modules/NavMenu.js";
import "./modules/HoverState.js";
import "./modules/BackdropOverlay.js";
import "./modules/RotateWords.js";
import "./modules/Lightbox.js";
import "./modules/Choices.js";
import "./modules/FadeInLater.js";
import Search from "./modules/Search.js";
import TimeNotifications from "./modules/Openingtimes.js"


// Blocks 

// Pages 


// Document ready
$(function(){
    let viewportWidth = $(window).width();

    // Homepage
    if ($('body.home').length){

    }
    
    const search = new Search();

    if (viewportWidth < 1024){

    }


});

$('.stop-propagation').on('click', function(e){
    e.stopPropagation();
});


// General function for one element triggering active on another
$(document).on('click', '[data-target]', function(){
    let target = $(this).data('target');
    let $target = $('.' + target);

    if ($target.hasClass('active')){
        $target.removeClass('active');
    }
    else{
        $target.addClass('active');
    }

    if ($(this).data('remove')){
        $(this).remove();
    }
});


